<template>
  <loading
    v-if="isLoading"
    :active.sync="isLoading"
    :can-cancel="canCancel"
    :is-full-page="fullPage"
    :color="color"
    :width="width"
    :height="height"
  ></loading>
</template>

<script>
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";

export default {
  name: "Loader",
  components: {
    Loading
  },
  props: {
    color: {
      default: "#ac8e59",
      type: String
    },
    width: {
      default: 100,
      type: Number
    },
    height: {
      default: 100,
      type: Number
    }
  },
  computed: {
    isLoading() {
      return this.$store.getters["configapp/isLoading"];
    },
    canCancel() {
      return this.$store.getters["configapp/canCancel"];
    },
    fullPage() {
      return this.$store.getters["auth/fullPage"];
    }
  }
};
</script>

<style scoped></style>
